import { File } from "@ticketrz/api-types";

export const isImage = (attachment: File & {
  signedPreviewUrl: string;
}): boolean => {
  return attachment.mimeType.includes("image/")
}